module.exports = __webpack_public_path__ + "static/media/user-graduate.a1eacbc6.svg";